/**
 * CoureHub.Broadcast.Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BroadcastMessage } from '../model/broadcastMessage';
import { CreateBroadcastMessageDto } from '../model/createBroadcastMessageDto';
import { DeliveryStatus } from '../model/deliveryStatus';
import { MessageType } from '../model/messageType';
import { ResponseDTO } from '../model/responseDTO';
import { RetryBroadcastMessageDto } from '../model/retryBroadcastMessageDto';
import { StringListResponseDTO } from '../model/stringListResponseDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BroadcastMessageService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBroadcastMessageCreatePost(body?: CreateBroadcastMessageDto, observe?: 'body', reportProgress?: boolean): Observable<ResponseDTO>;
    public apiBroadcastMessageCreatePost(body?: CreateBroadcastMessageDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseDTO>>;
    public apiBroadcastMessageCreatePost(body?: CreateBroadcastMessageDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseDTO>>;
    public apiBroadcastMessageCreatePost(body?: CreateBroadcastMessageDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ResponseDTO>('post',`${this.basePath}/api/BroadcastMessage/Create`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param deliveryStatus 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBroadcastMessageGetByServiceProviderIdAndDeliveryStatusGet(serviceProviderId?: string, deliveryStatus?: DeliveryStatus, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastMessage>>;
    public apiBroadcastMessageGetByServiceProviderIdAndDeliveryStatusGet(serviceProviderId?: string, deliveryStatus?: DeliveryStatus, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastMessage>>>;
    public apiBroadcastMessageGetByServiceProviderIdAndDeliveryStatusGet(serviceProviderId?: string, deliveryStatus?: DeliveryStatus, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastMessage>>>;
    public apiBroadcastMessageGetByServiceProviderIdAndDeliveryStatusGet(serviceProviderId?: string, deliveryStatus?: DeliveryStatus, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (deliveryStatus !== undefined && deliveryStatus !== null) {
            queryParameters = queryParameters.set('deliveryStatus', <any>deliveryStatus);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<BroadcastMessage>>('get',`${this.basePath}/api/BroadcastMessage/GetByServiceProviderIdAndDeliveryStatus`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param messageType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBroadcastMessageGetByServiceProviderIdAndMessageTypeGet(serviceProviderId?: string, messageType?: MessageType, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastMessage>>;
    public apiBroadcastMessageGetByServiceProviderIdAndMessageTypeGet(serviceProviderId?: string, messageType?: MessageType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastMessage>>>;
    public apiBroadcastMessageGetByServiceProviderIdAndMessageTypeGet(serviceProviderId?: string, messageType?: MessageType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastMessage>>>;
    public apiBroadcastMessageGetByServiceProviderIdAndMessageTypeGet(serviceProviderId?: string, messageType?: MessageType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (messageType !== undefined && messageType !== null) {
            queryParameters = queryParameters.set('messageType', <any>messageType);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<BroadcastMessage>>('get',`${this.basePath}/api/BroadcastMessage/GetByServiceProviderIdAndMessageType`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBroadcastMessageGetByServiceProviderIdGet(serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastMessage>>;
    public apiBroadcastMessageGetByServiceProviderIdGet(serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastMessage>>>;
    public apiBroadcastMessageGetByServiceProviderIdGet(serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastMessage>>>;
    public apiBroadcastMessageGetByServiceProviderIdGet(serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<BroadcastMessage>>('get',`${this.basePath}/api/BroadcastMessage/GetByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param refId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBroadcastMessageGetByrefIdGet(refId?: string, observe?: 'body', reportProgress?: boolean): Observable<BroadcastMessage>;
    public apiBroadcastMessageGetByrefIdGet(refId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BroadcastMessage>>;
    public apiBroadcastMessageGetByrefIdGet(refId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BroadcastMessage>>;
    public apiBroadcastMessageGetByrefIdGet(refId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (refId !== undefined && refId !== null) {
            queryParameters = queryParameters.set('refId', <any>refId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<BroadcastMessage>>('get',`${this.basePath}/api/BroadcastMessage/GetByrefId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBroadcastMessageGetDeliveryStatusGet(observe?: 'body', reportProgress?: boolean): Observable<StringListResponseDTO>;
    public apiBroadcastMessageGetDeliveryStatusGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StringListResponseDTO>>;
    public apiBroadcastMessageGetDeliveryStatusGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StringListResponseDTO>>;
    public apiBroadcastMessageGetDeliveryStatusGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StringListResponseDTO>('get',`${this.basePath}/api/BroadcastMessage/GetDeliveryStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBroadcastMessageGetMessageTypesGet(observe?: 'body', reportProgress?: boolean): Observable<StringListResponseDTO>;
    public apiBroadcastMessageGetMessageTypesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StringListResponseDTO>>;
    public apiBroadcastMessageGetMessageTypesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StringListResponseDTO>>;
    public apiBroadcastMessageGetMessageTypesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StringListResponseDTO>('get',`${this.basePath}/api/BroadcastMessage/GetMessageTypes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBroadcastMessageRetryPost(body?: RetryBroadcastMessageDto, observe?: 'body', reportProgress?: boolean): Observable<ResponseDTO>;
    public apiBroadcastMessageRetryPost(body?: RetryBroadcastMessageDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseDTO>>;
    public apiBroadcastMessageRetryPost(body?: RetryBroadcastMessageDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseDTO>>;
    public apiBroadcastMessageRetryPost(body?: RetryBroadcastMessageDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ResponseDTO>('post',`${this.basePath}/api/BroadcastMessage/Retry`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBroadcastMessageSendDraftMessagePost(body?: RetryBroadcastMessageDto, observe?: 'body', reportProgress?: boolean): Observable<ResponseDTO>;
    public apiBroadcastMessageSendDraftMessagePost(body?: RetryBroadcastMessageDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseDTO>>;
    public apiBroadcastMessageSendDraftMessagePost(body?: RetryBroadcastMessageDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseDTO>>;
    public apiBroadcastMessageSendDraftMessagePost(body?: RetryBroadcastMessageDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ResponseDTO>('post',`${this.basePath}/api/BroadcastMessage/SendDraftMessage`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
